import './PracticeItem.scss'
import {useContext} from "react";
import AppContext from "../AppContext";
export default function PracticeItem({ id, category, recommended, currentCat, setCurrentCat }) {
    const app = useContext(AppContext)
    let className = ['practice-item']

    const openCategory = () => {
        setCurrentCat(category)
    }

    if(category.completed)
        className.push('completed')
    else if(category.topics_completed && category.video_watched && category.questions.length > 0)
        className.push('finalize')

    if(recommended)
        className.push('current')
    else if(!category.completed && !recommended)
        className.push('locked')


    return <div id={id} className={className.join(' ')} onClick={openCategory}>
        <img src={category.image} alt="" />
        <div className="practice-item-info">
            <h3 className="title">
                <span dangerouslySetInnerHTML={{__html: category.name }} />
            </h3>
        </div>
    </div>
}